import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { Field } from "../../component";
import { dateFormat, getLocalstorage, isValidArray } from "../../helper";
import { ADD_DECISION } from "../../constant";

class IssueDecision extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agendaList: false,
      selectedAgenda: ""
    };
  }

  onChange = (value, key) => {
    this.props.onChangeAgenda(value, key);
  };

  onError = (value, key) => {};

  toggleAgendaList = () => {
    const { agendaList } = this.state;
    this.setState({
      agendaList: !agendaList
    });
  };

  render() {
    const {
      params,
      agendaDataList,
      agenda,
      agendasAssociatedWithIssue
    } = this.props;
    const { setMeetingType, withMeeting, issueDetails } = params || {};
    const { issueStatus, status } = issueDetails || {};
    const departmentUser = getLocalstorage("groupCategory");
    // const { agenda } = this.state;

    return (
      <React.Fragment>
        <div className="issue-decision">
          <div className="form-field field-select">
            <div className="form-field-data error-field agenda-tab-container">
              {departmentUser != "STATE_DEPARTMENT" && (
                <Form.Check
                  className={`form-checkbox ${withMeeting && "checked"} ${
                    issueStatus === "RESOLVED" || status === "Resolved"
                      ? "make-disable"
                      : ""
                  }`}
                >
                  <Form.Check.Input
                    type="checkbox"
                    name="started_implementation"
                  />
                  <Form.Text
                    className="form-checkbox-label"
                    onClick={() => {
                      if (issueStatus !== "RESOLVED" && status !== "Resolved")
                        setMeetingType && setMeetingType(true);
                    }}
                  >
                    {ADD_DECISION.WITH_AGENDA}
                  </Form.Text>
                </Form.Check>
              )}
              <Form.Check
                className={`form-checkbox ${!withMeeting && "checked"}`}
              >
                <Form.Check.Input
                  type="checkbox"
                  name="started_implementation"
                />
                <Form.Text
                  className="form-checkbox-label"
                  onClick={() => {
                    setMeetingType && setMeetingType(false);
                  }}
                >
                  {ADD_DECISION.WITHOUT_AGENDA}
                </Form.Text>
              </Form.Check>
            </div>
            {(withMeeting && isValidArray(agendaDataList) && (
              <React.Fragment>
                <Field
                  as="select"
                  keyName="agenda"
                  onError={this.onError}
                  onChange={this.onChange}
                  value={agenda}
                  className="select-agenda-dropdown decision-select-field"
                >
                  <option value="">Select Agenda</option>
                  {agendaDataList.map(data => {
                    return (
                      <option value={data.id} key={data.id}>
                        #{data.id} {data.meetingName}
                      </option>
                    );
                  })}
                </Field>
                {agendaDataList.map(data => {
                  if (data.id === parseInt(agenda)) {
                    let meetingMode = data.meetingMode
                      .toLowerCase()
                      .replace(/_/g, " ");
                    meetingMode = meetingMode.replace(/\b\w/g, function(l) {
                      return l.toUpperCase();
                    });

                    return (
                      <div className="selected-agenda-container">
                        <React.Fragment>
                          <div className="d-flex justify-content-between align-items-center flex-row mb-18">
                            <p>Meeting name: {data.meetingName} </p>
                            <p>Meeting type: {data.meetingType}</p>
                            <p>Chaired by: {data.meetingChairedBy}</p>
                          </div>
                          <div className="d-flex justify-content-between align-items-center flex-row">
                            <p>Date: {data.time && dateFormat(data.time)}</p>
                            <p>Venue: {data.venue}</p>
                            <p>Meeting mode: {meetingMode}</p>
                          </div>
                        </React.Fragment>
                      </div>
                    );
                  }
                  return null;
                })}
              </React.Fragment>
            )) ||
              null}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    meetingListData: state.issueDetailsReducer.meetingListData
  };
}

export default connect(
  mapStateToProps,
  null
)(IssueDecision);
